export const getallmall = `
query AllMallEntriesList {
    allMallEntriesList {
        id
        marketName
        address
        contactPerson
        contactNumber
        contractStart
        contractEnd
        completeWithin
        createdAt
        updatedAt
        agreedProducts {
            id
            quantity
            productCategory
            remarkSet{
              agreedProduct{
                reconciliationSet{
                  submitted
                    actualQuantity
                }
              }
            }
              reconciliationSet {
 
                id
 
                actualQuantity
 
                retailPrice
 
                submitted
 
                saved
 
                batchExpiry
 
                remarks
 
                imageBefore
 
                imageAfter
 
                createdAt
 
              }
            product {
                id
                productCode
                productName
                productCategory
                productBrandCode
                productBrand
                productImage
                productUom
                baseUom
                conversion
                vat
                bas
                cod
                csh
                smt
                vansl
                createdAt
                lastupdate
            }
        }
        role {
            id
            role
        }
       agent {
            employeeCode
            employeeName
            id
        }
    }
}


`;

export const getmallbyagent = `
query MallEntriesByAgent($agentId: Int!) {
  mallEntriesByAgent(agentId: $agentId) {
    id
    marketName
    address
    contactPerson
    contactNumber
    contractStart
    contractEnd
    completeWithin
    createdAt
    role {
      id
      role
    }
     agent {
            employeeCode
            employeeName
            id
        }
    agreedProducts {
      id
      quantity
      remarkSet{
            agreedProduct{
              reconciliationSet{
                submitted
                  actualQuantity
              }
            }
          }
              reconciliationSet {

                id

                actualQuantity

                retailPrice

                submitted

                saved

                batchExpiry

                remarks

                imageBefore

                imageAfter

                createdAt

              }
      product {
        id
        productCode
        productName
        productCategory
      }
    }
  }
}


`;

export const allUsers = `
  query {
    allUsers {
      id
      employeeName
      employeeCode
      email
      contactNumber
      address
      role {
        id
        role
      }

      department
      createdAt

      profilePicture

      webUse

      mobileUse
      isActive
    }
  }
`;

export const allProducts = `
  query {
    allProducts {
      success

      error

      message

      data {
        id

        productCode

        productName

        productCategory

        productBrandCode
        productImage

        productBrand

        productUom

        baseUom

        conversion

        vat

        bas

        cod

        csh

        smt

        vansl

        createdAt

        lastupdate
      }
    }
  }
`;

export const allreconcilation = `

query AllReconciliations {
    allReconciliations {
        id
        actualQuantity
        batchExpiry
        retailPrice
        remarks
        imageBefore
        imageAfter
        saved
        submitted
        agreedProduct {
            id
            quantity
            productCategory
            product {
                id
                productCode
                productName
                productCategory
                productBrandCode
                productBrand
                productImage
                productUom
                baseUom
                conversion
                vat
                bas
                cod
                csh
                smt
                vansl
                createdAt
                lastupdate
            }
            mallEntry {
                id
                marketName
                address
                contactPerson
                contactNumber
                contractStart
                contractEnd
                completeWithin
                createdAt
                updatedAt
                agent {
                    id
                    password
                    lastLogin
                    isSuperuser
                    username
                    firstName
                    lastName
                    isStaff
                    isActive
                    dateJoined
                    employeeName
                    employeeCode
                    email
                    contactNumber
                    address
                    department
                    profilePicture
                    mobileUse
                    webUse
                    createdAt
                    lastupdate
                }
            }
        }
    }
}


`;

export const allremarks = `
query AllRemarks {
    allRemarks {
        id
        text
        approvedStatus
        submittedBy {
            id
            password
            lastLogin
            isSuperuser
            username
            firstName
            lastName
            isStaff
            isActive
            dateJoined
            employeeName
            employeeCode
            email
            contactNumber
            address
            department
            profilePicture
            mobileUse
            webUse
            createdAt
            lastupdate
        }
        agreedProduct {
            id
            quantity
            productCategory
            product {
                id
                productCode
                productName
                productCategory
                productBrandCode
                productBrand
                productImage
                productUom
                baseUom
                conversion
                vat
                bas
                cod
                csh
                smt
                vansl
                createdAt
                lastupdate
            }
            mallEntry {
                id
                marketName
                address
                contactPerson
                contactNumber
                contractStart
                contractEnd
                completeWithin
                createdAt
                updatedAt
                agent {
                    id
                    password
                    lastLogin
                    isSuperuser
                    username
                    firstName
                    lastName
                    isStaff
                    isActive
                    dateJoined
                    employeeName
                    employeeCode
                    email
                    contactNumber
                    address
                    department
                    profilePicture
                    mobileUse
                    webUse
                    createdAt
                    lastupdate
                }
            }
        }
    }
}
`;

export const getslowproductsbyid = `
query GetSlowMovingProductById($id: Int!) {
  getSlowMovingProductById(id: $id) {
    success
    error
    message
    data {
      id
      productCode
      productName
      productCategory
      brand
      ageOfStock
      reasonForSlowMovement
      user {
        id
        username
        email
      }
      product {
        id
        productCode
        productName
      }
    }
  }
}


`;

export const slowmovingproductsreport = `
query SlowMovingProductReport(
  $startDate: Date
  $endDate: Date
  $productCategories: [String]
  $brands: [String]
  $userIds: [Int]
  $agentNames: [String]
  $agesOfStock: [Int]
  $productNames: [String]
) {
  slow_moving_product_report(
    start_date: $startDate
    end_date: $endDate
    product_categories: $productCategories
    brands: $brands
    user_ids: $userIds
    agent_names: $agentNames
    ages_of_stock: $agesOfStock
    product_names: $productNames
  ) {
    total_count
    items {
      product_name
      category
      brand
      stock_age
      quantity
      agent_name
      user_id
    }
  }
}



`;
